<template>
  <div class="box">
    <div class="box-title">{{ title }}</div>
    <div class="inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>

<style lang="stylus" scoped>
.box
  margin: 2em 0;
  background: #f1f1f1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.22);

.box .box-title
  font-size: 1.2em;
  background: #385168;
  padding: 4px;
  text-align: center;
  color: #FFF;
  font-weight: bold;
  letter-spacing: 0.05em;

.box .inner
  padding: 5px;

.box p
  padding: 15px 20px;
  margin: 0;
</style>
